<template>
  <el-dialog
    title="编辑仓库"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="model.name" class="fix-width"></el-input>
      </el-form-item>
      <el-form-item label="负责人" prop="user_id">
        <el-select
          class="fix-width"
          size="small"
          placeholder="请搜索或选择"
          filterable
          v-model="model.user_id"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域" prop="area">
        <el-select
          class="fix-width"
          size="small"
          placeholder="请选择区域"
          v-model="model.area"
        >
          <el-option
            v-for="item in areas"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="关联基地" prop="fix_base">
        <el-select
          class="fix-width"
          size="small"
          placeholder="请选择关联基地"
          v-model="model.fix_base"
          multiple=""
        >
          <el-option
            v-for="item in fix_bases"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { stockroomCreate, stockroomUpdate, userList } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    fix_bases: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      areas: [
        { id: 1, name: '总部' },
        { id: 2, name: '东北' },
        { id: 3, name: '西南' },
        { id: 4, name: '西北' },
        { id: 5, name: '陕北' },
        { id: 6, name: '中部' },
        { id: 7, name: '海锐' },
      ],
      visible: this.show,
      loading: false,
      users: [],
      rules: {
        name: [{ required: true, message: '请填写名称' }],
        user_id: [{ required: true, message: '请选择负责人' }],
        area: [{ required: true, message: '请选择区域' }],
      },
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      let res = await userList({ module_id: 5, size: 100 })
      if (res.status == 0) {
        this.users = res.data.list
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.user_name = this.users.filter(
            (item) => item.id == data.user_id
          )[0].name
          if (this.model.id > 0) {
            let res = await stockroomUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await stockroomCreate(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
</style>